import { AddCircleOutline, VideocamOutlined } from '@mui/icons-material'
import { useTheme } from '@mui/material'
import { Context } from 'react'
import { useTranslation } from 'react-i18next'
import ROVContainer from 'src/components/ROVContainer'
import { permissionValue } from 'src/enums/permissionValue'
import { IROVVideosWithSharedCategories } from 'src/generated-types/rovvideo'
import { MUIThemeColors } from 'src/mui-theme'
import { getThemeColor } from 'src/utils'
import EquipmentSectionLayout from './EquipmentSectionLayout'

interface Props {
  context: Context<any> | null | undefined
  customerId: EntityId | undefined
  localityId: EntityId | undefined
  mainComponentId: EntityId
  mooringId: EntityId | undefined
  rovVideosWithSharedCategories: IROVVideosWithSharedCategories | undefined
  selectedCategoryId: EntityId | null
  onCategoryChange: (categoryId: EntityId | null) => void
  onAddRovVideo: () => void
  isReadOnly?: boolean
}

const ROVSection = (props: Props) => {
  const {
    context,
    customerId,
    localityId,
    mainComponentId,
    mooringId,
    rovVideosWithSharedCategories,
    onCategoryChange,
    onAddRovVideo,
    isReadOnly,
  } = props
  const { t } = useTranslation(['rov'])
  const theme = useTheme()

  return (
    <EquipmentSectionLayout
      title={t('rov', { ns: 'rov' })}
      icon={<VideocamOutlined sx={{ fontSize: '18px', color: getThemeColor(theme, MUIThemeColors.primaryMain) }} />}
      buttonText={t('uploadVideo', { ns: 'rov' })}
      buttonIcon={<AddCircleOutline />}
      onButtonClick={onAddRovVideo}
      context={context}
      permissions={[
        permissionValue.Locality.MainComponent.Document.Write,
        permissionValue.ClientAdminPermission,
        permissionValue.ServiceStation.Write,
        permissionValue.ClientAdminPortal.Equipment_Portal,
      ]}
      content={
        <ROVContainer
          rovVideosWithSharedCategories={rovVideosWithSharedCategories}
          width={'100%'}
          localityId={localityId}
          customerId={customerId}
          mooringId={mooringId}
          mainComponentId={mainComponentId}
          onCategoryChange={onCategoryChange}
          rowFlex="0 1 calc(25% - 8px)"
          folderNameTruncateLength={15}
          maxHeight={'250px'}
          isAccordionGroups={false}
          accordionBorder={`1px dashed ${getThemeColor(theme, MUIThemeColors.secondaryLight)}`}
          minimalEmptyStatus={true}
          disabled={isReadOnly}
        />
      }
      isReadOnly={isReadOnly}
    />
  )
}

export default ROVSection
